// extracted by mini-css-extract-plugin
module.exports = {"content":"_54731ee2","expanded":"_10cab84c"};